import React from 'react'
import HeroDesktop from './components/HeroDesktop'
import HeroTablet from './components/HeroTablet'
import HeroMobile from './components/HeroMobile'

const Hero = () => {
  return (
    <>
      <div className="hidden lg:block">
        <HeroDesktop />
      </div>
      <div className="hidden md:block lg:hidden">
        <HeroTablet />
      </div>
      <div className="block md:hidden">
        <HeroMobile />
      </div>
    </>
  )
}

export default Hero